export default __webpack_public_path__ + "static/wwc-image1-2b860188d927d01a4cbdffbee6af955f.jpg";